import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './contributor';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { checkIfDistributorIndividual, checkSupportLogin } from '../../utils/utilityFunctions';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { auth } = useSelector((store: RootStateType) => store);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                RM/Distributor Details
              </Typography>
            </Grid>

            <Gridstyles sx={{ width: '100%' }}>
              <Grid
                item
                container
                pt={1}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                {!application.distributor_id && (
                  <>
                    <KeyValue title={'RM Name'} description={application?.rm?.user?.firstName} />
                    <KeyValue
                      title={'AMCs RM Email Id'}
                      description={application?.rm?.user?.email}
                    />
                    <KeyValue
                      title={'AMCs RM Mobile No'}
                      description={application?.rm?.user?.phone}
                    />
                  </>
                )}
                {application.distributor_id && (
                  <>
                    {checkIfDistributorIndividual(application?.distributor?.type) ? (
                      <>
                        {/* <Grid container rowSpacing={6} item direction="column" xs={12} md={6}> */}
                        <KeyValue
                          title={'Distributor ARN Code'}
                          description={application?.distributor?.arnCode}
                        />
                        <KeyValue
                          title={'Distributor Name'}
                          description={application?.distributor?.name}
                        />
                        <KeyValue
                          title={'Distributor Email'}
                          description={application?.distributor?.user?.email}
                        />
                        <KeyValue
                          title={'Distributor Mobile No'}
                          description={application?.distributor?.user?.phone}
                        />
                        {/* </Grid> */}
                      </>
                    ) : (
                      <>
                        <KeyValue
                          title={'Distributor ARN Code'}
                          description={application?.distributor?.arnCode}
                        />
                        <KeyValue
                          title={'Distributor Name'}
                          description={application?.distributor?.name}
                        />
                      </>
                    )}
                  </>
                )}
                {application.subdistributorId && (
                  <>
                    {/* <Grid container rowSpacing={6} item direction="column" xs={12} md={6}> */}
                    <KeyValue
                      title={'Distributor Sales RM Name'}
                      description={application?.subDistributor?.user?.firstName}
                    />
                    <KeyValue
                      title={'Distributor Sales RM Email ID'}
                      description={application?.subDistributor?.user?.email}
                    />
                    <KeyValue
                      title={'Distributor Sales RM Mobile No'}
                      description={application?.subDistributor?.user?.phone}
                    />
                    {/* </Grid> */}
                  </>
                )}
                {application?.supportSubdistributor?.user.id &&
                  !checkSupportLogin(
                    Number(auth.id),
                    Number(application?.supportSubdistributor?.user.id)
                  ) && (
                    <>
                      {/* <Grid rowSpacing={6} container item direction="column" xs={12} md={6}> */}
                      <KeyValue
                        title={'CXO Name'}
                        description={application?.supportSubdistributor?.user?.firstName}
                      />
                      <KeyValue
                        title={'CXO Email'}
                        description={application?.supportSubdistributor?.user?.email}
                      />
                      <KeyValue
                        title={'CXO Mobile No'}
                        description={application?.supportSubdistributor?.user?.phone}
                      />
                      {/* </Grid> */}
                    </>
                  )}
              </Grid>
            </Gridstyles>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
